import { render, staticRenderFns } from "./PrivacyPolicyDe.vue?vue&type=template&id=73bee691&"
import script from "./PrivacyPolicyDe.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyDe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports